



























































import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import Permit from './Permit';
import PermitCustomer from './PermitCustomer';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import PermitSearch from '@/Permit/Search/PermitSearch.vue';
import PermitPayment from '@/Permit/Payment/PermitPayment.vue';
import PermitApplication from '@/Permit/PermitApplication.vue';
import PermitVariables from '@/Permit/PermitVariables';
import RadioGroup from '@/Shared/RadioGroup.vue';
import { Logger } from '@/Shared/Logger';
import { Location } from '@/Stores/UserStore';
import { User } from '@/Stores/UserStore';
import { PermitMode, PermitRequestStatus } from './Enum';
import { AxiosResponse } from 'axios';
import { Route } from 'vue-router';
import UserMixin from '@/Shared/UserMixin';


const PermitPurchase = mixins(LocationBasedMixin, UserMixin).extend({
  components: {
    LocationLookupDropdown,
    PermitSearch,
    PermitApplication,
    RadioGroup,
    PermitPayment
  },
  props: {
    permitID: {
      required: false,
      type: String
    },
    permitMode: {
      required: true,
      type: String
    }
  },
  computed: {
    selectedPermitID(): string {
      return this.validPermitSelected ? this.permit.recID.toString() : '';
    },
    searchVehicleLicense(): string {
      return this.validPermitSelected ? this.permit.vehicleLicense : '';
    },
    maxVehicleYear(): number {
      return (new Date()).getFullYear() + 1;
    },
    validPermitSelected(): boolean {
      return (
        this.permit &&
        typeof this.permit.recID === 'number' &&
        this.permit.recID >= 0
      );
    },
    canCreateNew(): boolean {
      return false; // once implemented: !!this.isInternal;
    },
    createNew(): boolean {
      return this.permitMode === PermitMode.PermitCreate;
    },
    applyForNew(): boolean {
      return this.permitMode === PermitMode.PermitApply || this.permitMode === 'default';
    },
    findExisting(): boolean {
      return this.permitMode === PermitMode.PermitFind;
    },
    canApplyForNew(): boolean {
      return this.isInternal || !this.settings.onlineRenewalOnly;
    },
    canFindExisting(): boolean {
      return true;
    }
  },
  data() {
    return {
      permit: {} as Permit,
      i18nPrefix: 'payment.permitPayment',
      permitApplicationSuccess: false as boolean,
      settings: {} as PermitVariables
    };
  },
  async mounted() {
    await this.loadUser();
    await this.init();
  },
  methods: {
    async init() {
      if (this.location) {
          this.settings = (await VatsAPI.get(`/${this.location}/Permits/variables`)).data;
      }
      this.permit = {} as Permit;
    },
    permitSelected(permit: Permit) {
      this.permit = permit;
      this.$router.push({name: 'permitPayment',  params: { permitID: permit.recID.toString()}});
    },
    permitNotFound(recID: number) {
      this.permit = {} as Permit;
    },
    permitAppliedFor(permit: Permit) {
      if (this.settings.payAfterApproval && !this.isInternal && permit.cost > 0) {
        this.permitApplicationSuccess = true;

        this.$bvToast.toast(
          this.$i18n.t(`${this.i18nPrefix}.successfulApplicationSubmission`).toString(),
          {
            title: this.$i18n.t('common.success').toString(),
            autoHideDelay: 5000
          }
        );
      }
      else {
        this.$router.push({name: 'permitPayment',  params: {
            permitID: permit.recID.toString(), location: this.location
          }});
        this.permit = permit;
      }
    },
    async locationChanged() {
      await this.init();
    }
  }
});

export default PermitPurchase;
